import './App.scss';
import './Mobile.scss';
import './Rooms.scss';
import Navigation from './components/Navigation';
import Page from './components/Page'
import React , {useEffect,useState} from 'react';
import Drag from './cmd/drag';
import PopUp from './components/PopUp';
// import Parallax from './cmd/parallax';
// import ExtraHovers from './components/ExtraHovers';


function App() {
  const [dataLoaded, setDataLoaded] = useState(false)
  const[flowChartForthisLanguage, setFlowChartForthisLanguage] = useState(null)
  const [popupActive, setPopupActive] = useState(false);
  const [popupObject,setPopupObject] = useState([{}]);
  const [initialPopupIndex, setInitialPopupIndex] = useState(0)
  const [ignoreTracking, setIgnoreTracking] = useState(true)
//////////////////////////////////////////////////////////////////////////////////////////////////////////// delay
  function delay(time) 
    {
    return new Promise(resolve => setTimeout(resolve, time));
    }
//////////////////////////////////////////////////////////////////////////////////////////////////////////// format analitics string
const formatStr = function(str)
    {return str.replace(/[^0-9a-zA-Z\-]/gi, '-')          // remove all special characters first 
                .replace(/\s+/g, '-')                      // make all spaces into (-)
                .replace("--","-")                         // Clean up any double dashes
                .toLowerCase();}                           // lower case whats left
//////////////////////////////////////////////////////////////////////////////////////////////////////////// analytics (1)
const analytics= function(placement, linkID, seqNum)
    {
    // let dataLayer = window.dataLayer || {};               // need to define for local, because react
    // let placemFormatted = formatStr(placement);
    // let linkIDFormatted = formatStr(linkID);
    // let analOBJ ={
    //       event: 'e_linkClick',
    //       hmcName: 'hp-presence',
    //       seqNum: seqNum,
    //       linkPlacement: placemFormatted,
    //       linkID: linkIDFormatted + "-hp-presence"
    //       }
    // dataLayer.push(analOBJ);
    }
//////////////////////////////////////////////////////////////////////////////////////////////////////////// analytics (2) custom links
const analyticsCustom = function(placement, linkID)
    {
    // let dataLayer = window.dataLayer || {};       // need to define for local, because react
    // let placemFormatted = formatStr(placement);
    // let linkIDFormatted = formatStr(linkID);
    // let analOBJ ={
    //     event: 'e_linkClick',
    //     linkPlacement: placemFormatted,
    //     linkID: linkIDFormatted + "-hp-presence"
    //     }
    // dataLayer.push(analOBJ);
    }
////////////////////////////////////////////////////////////////////////////////////////////////////////////
function getDataFromAPI() 
  {
    // default to English USA
    let lang ='us-en'
    let dataPath = 'data/'
    const fullUrl = window.location
    const locationURL = window.location.href
    const params = new Proxy(new URLSearchParams(window.location.search), {get: (searchParams, prop) => searchParams.get(prop),});
    const urlPath = window.location.pathname;

    // change path if its not locally run
    // if(fullUrl.toString().indexOf('localhost') < 0)
    //   {
    //     dataPath = "/content/dam/sites/worldwide/apps/presence-configurator/static/js/json/"
    //   }
    // point to the correct langugage
    // if(locationURL.indexOf("ca-en") > -1)
    // {lang ="ca-en"}
    // if(locationURL.indexOf("ca-fr") > -1)
    // {lang ="ca-fr"}
    // if(locationURL.indexOf("au-en") > -1)
    // {lang ="au-en"}
    // if(locationURL.indexOf("uk-en") > -1)
    // {lang ="uk-en"}
    // if(locationURL.indexOf("ie-en") > -1)
    // {lang ="ie-en"}
    // if(locationURL.indexOf("de-de") > -1)
    // {lang ="de-de"}
    // if(locationURL.indexOf("fr-fr") > -1)
    // {lang ="fr-fr"}
    // if(locationURL.indexOf("be-nl") > -1)
    // {lang ="be-nl"}
    // if(locationURL.indexOf("be-fr") > -1)
    // {lang ="be-fr"}
    // if(locationURL.indexOf("dk-da") > -1)
    // {lang ="dk-da"}
    // if(locationURL.indexOf("fi-fi") > -1)
    // {lang ="fi-fi"}
    // if(locationURL.indexOf("nl-nl") > -1)
    // {lang ="nl-nl"}
    // if(locationURL.indexOf("no-no") > -1)
    // {lang ="no-no"}
    // if(locationURL.indexOf("se-sv") > -1)
    // {lang ="se-sv"}
    // if(locationURL.indexOf("ch-de") > -1)
    // {lang ="ch-de"}
    // if(locationURL.indexOf("ch-fr") > -1)
    // {lang ="ch-fr"}


    console.log('getting data from::::::::: ', `${dataPath}${lang}.json`)
    
    return fetch(`${dataPath}${lang}.json`)
          .then((response) => 
              response.json())
          .then((responseJson) => 
            {
              setFlowChartForthisLanguage(responseJson);
              setDataLoaded(true)
            })
          .catch((error) => 
            {console.error(error);});
  }


  
  // this is for nav menu only
  const paginate = function (currentPage) 
    {
    document.body.classList = currentPage
    let xCoor = 0;
    let offset = -70
    let a = document.querySelector('.nav-wrap .Size-focus').offsetWidth;
    let b = document.querySelector('.nav-wrap .Size-huddle').offsetWidth;
    let c = document.querySelector('.nav-wrap .Size-small').offsetWidth;
    let d = document.querySelector('.nav-wrap .Size-medium').offsetWidth;
    let e = document.querySelector('.nav-wrap .Size-large').offsetWidth;



    if(currentPage ==="Size-focus"){xCoor =0}
    else if(currentPage ==="Size-huddle"){xCoor = a +offset}
    else if(currentPage ==="Size-small"){xCoor  = a+ b +offset}
    else if(currentPage ==="Size-medium"){xCoor = a +b+c+offset}
    else if(currentPage ==="Size-large"){xCoor  = a +b+c+d+offset}

    document.querySelector('.nav-wrap').scrollTo(xCoor,0)
    /////////////////////////////////////////////////////////////////////////////////////////////////// ANALYTICS
    // if(ignoreTracking === false )
    //     {analytics("room-size", currentPage.replace("Size-",""), "01");}                                      // the first click is forced, so we dont track it
    // else
    //     {
    //     delay(2500).then(() => {setIgnoreTracking(false);/*console.log('///// events will now be tracked')*/ }); // wait one sec before tracking
    //     }
    startHoverAnimations();   //<--------- temp disable
    }
  //
  const highlighFirstOption= function()
    {
    const firstOptions = document.querySelectorAll('.switch div:first-child input');
    for(let i=0;i< firstOptions.length;i++) 
        {firstOptions[i].checked = true}
    }

  //
  function openCustomKit(pop, defaultSlideIndex)
    {
    setPopupObject(pop)
    setInitialPopupIndex(defaultSlideIndex)
    setPopupActive(true)
    }
  //
  function closePopup()
    {setPopupActive(false)}
//
const  preloadCamHovers = function()
  {
    window.preloadedPictures = []
    for(let i=0;i<120; i++)
      {
        const newImage = new Image();
        //newImage.src = "http://localhost:3000/img/wall/"+(1000+i)+".png";
        newImage.src = "https://www.hp.com/content/dam/sites/worldwide/apps/presence-configurator/img/wall/"+(1000+i)+".png"
        window.preloadedPictures.push( newImage );
        // console.log('loaded '+i)
      }
  }
///
const addGhostClicks = function()
    {
      document.body.addEventListener('click', function(event)
        {
        let posY=  event.type === "touchmove" ? event.touches[0].clientY : event.clientY

        if(posY>60 && document.querySelector('.container').classList.contains('animationsRunning'))  /// should check if overlay is present first
              {
              const allRoomObjects = document.querySelectorAll('.roomObject img')
              for(let i=0;i< allRoomObjects.length ;i++)
                  {
                  let img = allRoomObjects[i];
                  let divRect = img.getBoundingClientRect();
                  if (event.clientX >= divRect.left && event.clientX <= divRect.right && event.clientY >= divRect.top && event.clientY <= divRect.bottom)
                        {img.click();}
                  }
              }

        }, false);
    }
////////////////////////////////////////////////////////////////////////////// run this on page first load only
useEffect(() => 
  {
  if(dataLoaded)
      {
      addGhostClicks();         
      highlighFirstOption()     
      preloadCamHovers();       

      let navbtnWidth = window.innerWidth > 700 ? 180 : 90
      const drag = new Drag('.nav','.pageWrap','.App',4,window.innerWidth);
      // const parallax = new Parallax('.pageWrap')
      const initialPos = document.querySelector("nav .Size-small")

      document.body.classList = "Size-small";
      document.querySelector('nav').scrollLeft = 1 * navbtnWidth - 80; 
      initialPos.click();  
      startHoverAnimations();   
      }
  }, [dataLoaded]); 






////////////////////////////////////////////////////////////////////////////////////////////////////////////
    useEffect(() => {getDataFromAPI() }, []); 
////////////////////////////////////////////////////////////////////////////////////////////////////////////


//
const fixmobileVHBug= function()
  {
  const vh = window.window.innerHeight;
  const vw = window.window.innerWidth;
  const h1 = document.querySelectorAll('.page-inner h1')
  const par = document.querySelectorAll('.page-inner p.hasParallax')
  const btn = document.querySelectorAll('.page-inner .questionDrawerButton')

  if (vw <=700)
      {
        for(let i=0; i< h1.length; i++)
          {
          let hHeight = h1[i].offsetHeight;
          h1[i].style.cssText = 'top:'+ (vh - (hHeight +130))+ 'px;bottom:auto !important;line-height:1em;padding:0;margin-top:0';
          }
        for(let j=0; j< par.length; j++)
          {
            par[j].style.cssText = 'top:'+ (vh -115)+ 'px;bottom:auto !important;line-height:1em;padding:0;margin-top:0';
          }
        for(let j=0; j< btn.length; j++)
          {
          btn[j].style.cssText = 'top:'+ (vh -75)+ 'px;bottom:auto !important;margin-top:0';
          }
      }
    else
      {
        for(let i=0; i< h1.length; i++)
          {h1[i].style.cssText = '';}
        for(let j=0; j< par.length; j++)
          {par[j].style.cssText = '';}
        for(let j=0; j< btn.length; j++)
          {btn[j].style.cssText += '';}
      }
  }
//
const startHoverAnimations= function()
  {
  fixmobileVHBug();
  const products = document.querySelectorAll(".roomObject") 
  window.hoveranimationCounter =  window.hoveranimationCounter  || null

  //let draggable =document.querySelector('.container')

  if( document.querySelector('.container').classList.contains('animationsRunning'))
    {
      clearTimeout(window.hoveranimationCounter);
      for(let i=0; i< products.length; i++)
        {
        products[i].classList.remove("hover")
        }
    }
  for(let i=0; i< products.length; i++)
    {
    products[i].classList.add("hover")
    document.querySelector('.container').classList.add('animationsRunning')
    }
  window.hoveranimationCounter = setTimeout
      (       // make products ready for next animation (hover or page transition)
      function()
        {
        for(let i=0; i< products.length; i++)
            {products[i].classList.remove("hover")}
            document.querySelector('.container').classList.remove('animationsRunning')
        }, 4000
      );
  }



//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// Core logic for showing products
const getCurrentBestKit = function (room, camera, audio) 
{
let bestKit = 0
//////////////////////////////////////// room 1
if (room === "Size-focus") 
  { 
    if (camera === "24") { bestKit = 9 }                                 // 24" display
    else if (camera === "27") { bestKit = 0 }                            // 27" display
    
  }                                                      
//////////////////////////////////////// room 2/
else if (room === "Size-huddle") 
  {
  if (camera === "No") { bestKit = 1 }                                  ////// Kit1
  else if (camera === "Yes") 
      {
      if (audio === "Front-of-room") { bestKit = 3 }                    ////// Kit3
      else if (audio === "Center-of-table") { bestKit = 2 }             ////// Kit2
      }
  }
//////////////////////////////////////// room 3
  else if (room === "Size-small") 
  {
  if (camera === "No") { bestKit = 10 }                                  ////// Kit1 for room small
  else if (camera === "Yes") 
      {
      if (audio === "Front-of-room") { bestKit = 12 }                    ////// Kit3 for room small
      else if (audio === "Center-of-table") { bestKit = 11 }             ////// Kit2 for room small
      }
  }
// //////////////////////////////////////// room 4
else if (room === "Size-medium") 
  {
  if (camera === "No") { bestKit = 4 }                                  ////// Kit4
  else if (camera === "Yes") 
      {
      if (audio === "Front-of-room") { bestKit = 13 }                   ////// Kit3 for medium
      else if (audio === "Center-of-table") { bestKit = 5 }             ////// Kit5
      }
  }
//////////////////////////////////////// room 5
else if (room === "Size-large") 
  {
  if (camera === "No") { bestKit = 7 }                                  ////// Kit4Plus
  else if (camera === "Yes") 
      {
      if (audio === "Front-of-room") { bestKit = 8 }                    ////// Kit6
      else if (audio === "Center-of-table") { bestKit = 8 }             ////// Kit5Plus
      }
  }
return flowChartForthisLanguage.Kits[bestKit]
}

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////
 
  return (
    flowChartForthisLanguage=== null ? <div id="loading">Loading...</div>:
          <div className={`App`}>
            <Navigation links={flowChartForthisLanguage.QandA[0]} paginate={paginate}/>
            <div className="container" id="container">
            <div className="pageWrap draggable">
            
              {flowChartForthisLanguage.QandA[0].sections.map(
                (sec) => {
                  return (
                    <Page
                      key={sec.ID}
                      id={sec.ID}
                      analytics={analytics}
                      analyticsCustom={analyticsCustom}
                      h1={sec.text}
                      count={sec.count}
                      dimensions={sec.dimensions}
                      questions={sec.questions}
                      roomImgSrc={sec.imageSrc}
                      openCustomKit= {openCustomKit}
                      closePopup= {closePopup}
                      commonText ={flowChartForthisLanguage.commonText}
                      getCurrentBestKit = {getCurrentBestKit}
                      defaultKit ={getCurrentBestKit( sec.ID,"Yes","Front-of-room")}
                    />
                  )
                }
              )}


            </div>
            </div>
              {popupActive === true ? <PopUp closePopup={closePopup} 
                                      popupObject={popupObject} 
                                      initialPopupIndex={initialPopupIndex} 
                                      analyticsCustom={analyticsCustom}/> : ""}
          </div>
  );
}


export default App;
